import React, { useState } from 'react';

import { Divider, Header } from 'semantic-ui-react';
import { Card } from '../Components/Card';
import { Input } from '../Components/Input';
import { Locale } from '../Components/Locale';
import { Grid, Column } from '../Components/Grid';
import { MdnLink } from '../Components/MdnLink';
import { Options, RuleSet } from '../Components/Options';
import { Segment } from '../Components/Segment';
import { Function } from '../Components/Function';
import { AllLocales } from '../Components/AllLocales';
import { useSelectedLocales } from '../hooks/useLocales';
import { Description } from '../Components/Description';
import { InputType } from '../types';


export type IntlFunctionProps = {
	input: InputType;
	mdnLink: string;
	header: string;
	description: string;
	options: Record<string, readonly (string | boolean | number)[]>;
	ruleSet?: RuleSet;
	template: string;
};

export const IntlFunction: React.FC<IntlFunctionProps> = ({
	input: defaultInput,
	mdnLink,
	header,
	description,
	options,
	ruleSet,
	template
}) => {
	const [inputs, setInputs] = useState<InputType>(defaultInput);
	const [locale, setLocale] = useState<string | string[]>(useSelectedLocales()[0]);
	const [selectedOptions, setSelectedOptions] = useState<
		Record<string, number | boolean | string>
	>({});

	const [evalWithLocale, setEvalWithLocale] = useState<(locale: string) => string>(() => () =>
		''
	);

	return (
		<Segment basic>
			<MdnLink link={mdnLink}>{header}</MdnLink>
			<Description>{description}</Description>
			<Grid>
				<Column width={10}>
					<Segment basic>
						<Card>
							<Header as="h2">Set up your formatter</Header>
							<Locale onChange={setLocale} />
							<Divider />

							<Options
								options={options}
								onChange={setSelectedOptions}
								ruleSet={ruleSet}
							/>
							<Divider />

							{defaultInput.length > 0 && <Input values={inputs} onChange={setInputs} />}
						</Card>
					</Segment>
				</Column>
				<Column width={6}>
					<Function
						args={{ locale, options: selectedOptions, inputs }}
						template={template}
						onEvaluate={(e) => {
							setEvalWithLocale(() => e);
						}}
					/>
				</Column>
			</Grid>
			<AllLocales evalWithLocale={evalWithLocale} />
		</Segment>
	);
};
